const AdminLayout = ({ children }) => {
    return (
        <div className="h-full mx-4 bg-raisin-black rounded-r-2xl rounded-l-2xl">
            {children}
        </div>
    );
};

export default AdminLayout;